(function () {
  'use strict';

  var config = window.SpikeConsentConfig || {};
  var root = document.getElementById('SpikeCookieConsent');
  var reopenButton = document.querySelector('[data-spike-consent-reopen]');
  var summary = root && root.querySelector('[data-spike-consent-summary]');
  var preferences = root && root.querySelector('[data-spike-consent-preferences]');
  var api = null;
  var loaded = { analytics: false, marketing: false };
  var lastFocused = null;

  function gtagConsent(state) {
    if (typeof window.gtag !== 'function') return;
    var marketing = Boolean(state.marketing);
    var saleOfData = state.saleOfData !== false;
    window.gtag('consent', 'update', {
      analytics_storage: state.analytics ? 'granted' : 'denied',
      ad_storage: marketing ? 'granted' : 'denied',
      ad_user_data: marketing && saleOfData ? 'granted' : 'denied',
      ad_personalization: marketing && saleOfData ? 'granted' : 'denied',
      functionality_storage: state.preferences ? 'granted' : 'denied',
      personalization_storage: state.preferences ? 'granted' : 'denied',
      security_storage: 'granted'
    });
  }

  function appendScript(id, src) {
    if (document.getElementById(id)) return;
    var script = document.createElement('script');
    script.id = id;
    script.async = true;
    script.src = src;
    document.head.appendChild(script);
  }

  function loadHotjar() {
    if (loaded.analytics || !config.hotjarId) return;
    loaded.analytics = true;
    window.hj = window.hj || function () { (window.hj.q = window.hj.q || []).push(arguments); };
    window._hjSettings = { hjid: Number(config.hotjarId), hjsv: 6 };
    appendScript('spike-hotjar', 'https://static.hotjar.com/c/hotjar-' + window._hjSettings.hjid + '.js?sv=' + window._hjSettings.hjsv);
  }

  function loadLeadhub() {
    if (loaded.marketing || !config.leadhubSrc) return;
    loaded.marketing = true;
    window.LeadhubData = { cart: config.cart || {} };
    appendScript('spike-leadhub', config.leadhubSrc);
  }

  function currentState() {
    return {
      preferences: api.preferencesProcessingAllowed(),
      analytics: api.analyticsProcessingAllowed(),
      marketing: api.marketingAllowed(),
      saleOfData: api.saleOfDataAllowed()
    };
  }

  function currentDecision() {
    if (!api || typeof api.currentVisitorConsent !== 'function') return {};
    return api.currentVisitorConsent() || {};
  }

  function hasDecision() {
    var decision = currentDecision();
    return decision.preferences !== '' || decision.analytics !== '' || decision.marketing !== '';
  }

  function populateChoices() {
    var decision = currentDecision();
    var state = currentState();
    ['preferences', 'analytics', 'marketing'].forEach(function (purpose) {
      var input = root && root.querySelector('[data-spike-consent-purpose="' + purpose + '"]');
      if (!input) return;
      if (decision[purpose] === 'yes') input.checked = true;
      else if (decision[purpose] === 'no') input.checked = false;
      else input.checked = Boolean(state[purpose]);
    });
  }

  function show(panel) {
    if (!root) return;
    lastFocused = document.activeElement;
    root.hidden = false;
    reopenButton.hidden = true;
    document.body.classList.add('spike-consent-open');
    summary.hidden = panel === 'preferences';
    preferences.hidden = panel !== 'preferences';
    if (panel === 'preferences') {
      populateChoices();
      var firstChoice = root.querySelector('[data-spike-consent-purpose]');
      if (firstChoice) firstChoice.focus();
    }
  }

  function hide() {
    if (!root) return;
    root.hidden = true;
    reopenButton.hidden = false;
    document.body.classList.remove('spike-consent-open');
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  function sync() {
    if (!api) return;
    var state = currentState();
    gtagConsent(state);
    if (state.analytics) loadHotjar();
    if (state.marketing) loadLeadhub();

    var consentRequired = typeof api.shouldShowBanner === 'function' && api.shouldShowBanner();
    if (consentRequired && !hasDecision()) show('summary');
    else if (root && root.hidden) reopenButton.hidden = false;

    document.documentElement.setAttribute('data-spike-consent-ready', 'true');
    document.dispatchEvent(new CustomEvent('spikeConsentReady', { detail: state }));
  }

  function saveConsent(next) {
    if (!api || typeof api.setTrackingConsent !== 'function') return;
    var before = currentState();
    api.setTrackingConsent(next, function () {
      var after = currentState();
      var revokedLoadedTracker = (loaded.analytics && before.analytics && !after.analytics) ||
        (loaded.marketing && before.marketing && !after.marketing);
      hide();
      sync();
      if (revokedLoadedTracker) window.location.reload();
    });
  }

  function bind() {
    if (!root || !reopenButton) return;
    function moveReopenButton() {
      var target = document.querySelector('[data-spike-consent-reopen-target]');
      if (target) target.appendChild(reopenButton);
    }
    moveReopenButton();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', moveReopenButton, { once: true });
    root.addEventListener('click', function (event) {
      event.stopPropagation();
    });
    root.querySelector('[data-spike-consent-accept]').addEventListener('click', function () {
      saveConsent({ preferences: true, analytics: true, marketing: true });
    });
    root.querySelector('[data-spike-consent-reject]').addEventListener('click', function () {
      saveConsent({ preferences: false, analytics: false, marketing: false });
    });
    root.querySelector('[data-spike-consent-customize]').addEventListener('click', function () {
      show('preferences');
    });
    root.querySelector('[data-spike-consent-back]').addEventListener('click', function () {
      show('summary');
    });
    root.querySelector('[data-spike-consent-save]').addEventListener('click', function () {
      saveConsent({
        preferences: root.querySelector('[data-spike-consent-purpose="preferences"]').checked,
        analytics: root.querySelector('[data-spike-consent-purpose="analytics"]').checked,
        marketing: root.querySelector('[data-spike-consent-purpose="marketing"]').checked
      });
    });
    reopenButton.addEventListener('click', function (event) {
      event.stopPropagation();
      show('summary');
    });
  }

  function init() {
    bind();
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      document.documentElement.setAttribute('data-spike-consent-ready', 'error');
      return;
    }
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (error || !window.Shopify.customerPrivacy) {
        document.documentElement.setAttribute('data-spike-consent-ready', 'error');
        return;
      }
      api = window.Shopify.customerPrivacy;
      sync();
      document.addEventListener('visitorConsentCollected', sync);
    });
  }

  init();
})();
